const DETAILS_MODAL_SCROLL_LOCK_OWNER = 'details-modal';

class DetailsModal extends HTMLElement {
  constructor() {
    super();
    this.detailsContainer = this.querySelector('details');
    this.summaryToggle = this.querySelector('summary');

    this.detailsContainer.addEventListener('keyup', (event) => event.code.toUpperCase() === 'ESCAPE' && this.close());
    this.summaryToggle.addEventListener('click', this.onSummaryClick.bind(this));
    this.querySelector('button[type="button"]').addEventListener('click', this.close.bind(this));

    this.summaryToggle.setAttribute('role', 'button');
  }

  isOpen() {
    return this.detailsContainer.hasAttribute('open');
  }

  onSummaryClick(event) {
    event.preventDefault();
    event.target.closest('details').hasAttribute('open') ? this.close() : this.open(event);
  }

  onBodyClick(event) {
    if (!this.contains(event.target) || event.target.classList.contains('modal-overlay')) this.close(false);
  }

  open(event) {
    this.onBodyClickEvent = this.onBodyClickEvent || this.onBodyClick.bind(this);
    event.target.closest('details').setAttribute('open', true);
    document.body.addEventListener('click', this.onBodyClickEvent);

    if (window.DrBodyScrollLock) {
      window.DrBodyScrollLock.lock(DETAILS_MODAL_SCROLL_LOCK_OWNER, 'overflow-hidden');
    } else {
      // iOS Safari ignores overflow:hidden on body; position:fixed + restore scroll locks background.
      this.scrollLockY = window.scrollY || document.documentElement.scrollTop || 0;
      document.body.style.position = 'fixed';
      document.body.style.top = `-${this.scrollLockY}px`;
      document.body.style.left = '0';
      document.body.style.right = '0';
      document.body.style.width = '100%';
      document.body.classList.add('overflow-hidden');
    }

    trapFocus(
      this.detailsContainer.querySelector('[tabindex="-1"]'),
      this.detailsContainer.querySelector('input:not([type="hidden"])')
    );

    if (this.classList.contains('header__search') || this.querySelector('.search-modal')) {
      window.dispatchEvent(new CustomEvent('search:modal:open'));
    }
  }

  close(focusToggle = true) {
    removeTrapFocus(focusToggle ? this.summaryToggle : null);
    this.detailsContainer.removeAttribute('open');
    document.body.removeEventListener('click', this.onBodyClickEvent);
    if (window.DrBodyScrollLock) {
      window.DrBodyScrollLock.unlock(DETAILS_MODAL_SCROLL_LOCK_OWNER);
    } else {
      document.body.classList.remove('overflow-hidden');

      const scrollY = this.scrollLockY ?? 0;
      document.body.style.position = '';
      document.body.style.top = '';
      document.body.style.left = '';
      document.body.style.right = '';
      document.body.style.width = '';
      this.scrollLockY = undefined;

      requestAnimationFrame(() => {
        window.scrollTo(0, scrollY);
      });
    }
  }
}

customElements.define('details-modal', DetailsModal);
